import { render, staticRenderFns } from "./auto-assign.vue?vue&type=template&id=116152af&scoped=true&"
import script from "./auto-assign.component.ts?vue&type=script&lang=ts&"
export * from "./auto-assign.component.ts?vue&type=script&lang=ts&"
import style0 from "./auto-assign.scss?vue&type=style&index=0&id=116152af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116152af",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/www/planning-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('116152af')) {
      api.createRecord('116152af', component.options)
    } else {
      api.reload('116152af', component.options)
    }
    module.hot.accept("./auto-assign.vue?vue&type=template&id=116152af&scoped=true&", function () {
      api.rerender('116152af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/last-mile-delivery-pricerite/auto-assign/auto-assign.vue"
export default component.exports